import React, {Component} from 'react';
import { withTranslation } from 'react-i18next';

class TiendaNubeAccountConfigurationClass extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // selectionMethod: this.props.selectionMethod || METHOD_ECOMMERCE_INCLUDE_ALL_CHANNELS_AND_TYPES,
            // selectedChannelsAndTypes: this.props.selectedChannelsAndTypes || [],
            // allChannelsAndTypes: null,
            loading: false,
            error: null
        };

        // this.handleSelectionMethodChange = this.handleSelectionMethodChange.bind(this);
        // this.handleChannelsAndTypesChange = this.handleChannelsAndTypesChange.bind(this);
    }

    // componentDidMount() {
    //     if (this.state.selectionMethod === METHOD_ECOMMERCE_SELECT_CHANNELS_AND_TYPES) {
    //         this.loadChannelsAndTypes();
    //     }
    // }

    // componentDidUpdate(prevProps) {
        // if (prevProps.selectionMethod !== this.props.selectionMethod) {
        //     this.setState({
        //         selectionMethod: this.props.selectionMethod || METHOD_ECOMMERCE_INCLUDE_ALL_CHANNELS_AND_TYPES
        //     });
        // }

        // if (prevProps.selectedChannelsAndTypes !== this.props.selectedChannelsAndTypes) {
        //     this.setState({
        //         selectedChannelsAndTypes: this.props.selectedChannelsAndTypes || []
        //     });
        // }

        // if (this.state.selectionMethod === METHOD_ECOMMERCE_SELECT_CHANNELS_AND_TYPES && 
        //     this.state.allChannelsAndTypes === null && 
        //     !this.state.loading) {
        //     this.loadChannelsAndTypes();
        // }
    // }

    // loadChannelsAndTypes() {
    //     this.setState({ loading: true, error: null });
        
    //     const url = `${API_URL}agency/ad-accounts/${this.props.adAccountId}/sessions`;
        
    //     new APIClient(url).call('GET')
    //         .then((response) => {
    //             if (response.data && Array.isArray(response.data)) {
    //                 // Procesar y agrupar los datos únicos por channel_name y referrer_source
    //                 const uniqueChannelsAndTypes = this.processSessionsData(response.data);
    //                 this.setState({
    //                     allChannelsAndTypes: uniqueChannelsAndTypes,
    //                     loading: false
    //                 });
    //             } else if (response.errors && response.errors.length > 0) {
    //                 this.setState({
    //                     error: response.errors.join(', ') || 'Error al cargar canales y tipos',
    //                     loading: false
    //                 });
    //             } else {
    //                 this.setState({
    //                     error: 'Error al cargar canales y tipos',
    //                     loading: false
    //                 });
    //             }
    //         })
    //         .catch((error) => {
    //             this.setState({
    //                 error: 'Error al cargar canales y tipos',
    //                 loading: false
    //             });
    //         });
    // }

    processSessionsData(sessionsData) {
        // Crear un Set para almacenar combinaciones únicas de channel_name y referrer_source
        const uniqueCombinations = new Set();
        const processedData = [];

        sessionsData.forEach(session => {
            const key = `${session.channel_name}_${session.referrer_source}`;
            if (!uniqueCombinations.has(key)) {
                uniqueCombinations.add(key);
                processedData.push({
                    channel_name: session.channel_name,
                    referrer_source: session.referrer_source,
                    count: session.count
                });
            }
        });

        return processedData;
    }

    getChannelLogo(referrerSource) {
        // Mapear referrer_source a logos conocidos
        const logoMap = {
            'google': 'GOOGLE',
            'facebook': 'FACEBOOK',
            'instagram': 'FACEBOOK', // Instagram usa el logo de Facebook
            'tiktok': 'TIKTOK',
            'linkedin': 'LINKEDIN',
            'direct': null, // Direct no tiene logo específico
            'organic': 'GOOGLE', // Organic search generalmente es Google
            'paid': null // Paid puede ser de varios canales
        };

        return logoMap[referrerSource?.toLowerCase()] || null;
    }

    // handleSelectionMethodChange(event) {
    //     const newMethod = event.target.value;
    //     this.setState({ selectionMethod: newMethod });
        
    //     if (this.props.onItemsSelectionMethodChange) {
    //         this.props.onItemsSelectionMethodChange(newMethod);
    //     }

    //     if (newMethod === METHOD_ECOMMERCE_SELECT_CHANNELS_AND_TYPES && this.state.allChannelsAndTypes === null) {
    //         this.loadChannelsAndTypes();
    //     }
    // }

    // handleChannelsAndTypesChange(selectedIds) {
    //     this.setState({ selectedChannelsAndTypes: selectedIds });
        
    //     if (this.props.onItemsSelectionChange) {
    //         this.props.onItemsSelectionChange(selectedIds);
    //     }
    // }

    // formatChannelAndTypeForMultiSelect(item) {
    //     const referrerSource = item.referrer_source || '';
    //     const channelName = item.channel_name || '';
    //     const channelLogoKey = this.getChannelLogo(referrerSource);
        
    //     return {
    //         id: `${channelName}_${referrerSource}`,
    //         name: `${channelName} - ${referrerSource}`,
    //         is_active: true,
    //         channel: channelName,
    //         type: referrerSource,
    //         channel_name: channelName,
    //         type_name: referrerSource,
    //         channel_logo_key: channelLogoKey,
    //         count: item.count
    //     };
    // }

    // renderChannelsAndTypesMultiSelect() {
    //     const { t } = this.props;
    //     if (!this.state.allChannelsAndTypes || !Array.isArray(this.state.allChannelsAndTypes)) {
    //         return null;
    //     }
        
    //     const formattedItems = this.state.allChannelsAndTypes.map(item => this.formatChannelAndTypeForMultiSelect(item));
        
    //     return (
    //         <div style={{width:"100%", whiteSpace: "nowrap"}}>
    //             <ul className="multi-select-list">
    //                 {formattedItems.map((item) => (
    //                     <MultiSelectChannelAndTypeItem
    //                         readOnly={false}
    //                         key={item.id}
    //                         itemId={item.id}
    //                         itemName={item.name}
    //                         channelName={item.channel_name}
    //                         typeName={item.type_name}
    //                         channelLogoKey={item.channel_logo_key}
    //                         checked={this.state.selectedChannelsAndTypes.includes(item.id)}
    //                         onChange={this.handleChannelAndTypeChange}
    //                     />
    //                 ))}
    //             </ul>
    //             <div className="select-options">
    //                 <button onClick={this.handleSelectAll}>{t('multiselect.select_all')}</button>
    //                 <button onClick={this.handleUnselectAll}>{t('multiselect.remove_selection')}</button>
    //             </div>
    //         </div>
    //     );
    // }

    // handleChannelAndTypeChange(event) {
    //     const isChecked = event.target.checked;
    //     const itemId = event.target.dataset.id;
    //     let selectedItems = null;
        
    //     if (isChecked) {
    //         selectedItems = [...this.state.selectedChannelsAndTypes, itemId];
    //     } else {
    //         selectedItems = this.state.selectedChannelsAndTypes.filter(id => id !== itemId);
    //     }
        
    //     this.handleChannelsAndTypesChange(selectedItems);
    // }

    // handleSelectAll = (event) => {
    //     event.preventDefault();
    //     if (!this.state.allChannelsAndTypes || !Array.isArray(this.state.allChannelsAndTypes)) {
    //         return;
    //     }
    //     const allIds = this.state.allChannelsAndTypes.map(item => 
    //         this.formatChannelAndTypeForMultiSelect(item).id
    //     );
    //     this.handleChannelsAndTypesChange(allIds);
    // }

    // handleUnselectAll = (event) => {
    //     event.preventDefault();
    //     this.handleChannelsAndTypesChange([]);
    // }

    render() {
        return (
            <div className="section-toggle" style={{ padding: '5px' }}>
                <a style={{ color: '#B6B6B7', textDecoration: 'none', cursor: 'default' }}>
                    Se incluye todo el tráfico de la tienda
                </a>
            </div>
        );

        // const { t } = this.props;
        // return [
        //     <div key="selection_method" className="form-row">
        //         <label>{t('tienda_nube_account_config.selection_method_label')}</label>
        //         <select 
        //             onChange={this.handleSelectionMethodChange} 
        //             name="selectionMethod" 
        //             required="required"
        //             value={this.state.selectionMethod}
        //         >
        //             <option value={METHOD_ECOMMERCE_INCLUDE_ALL_CHANNELS_AND_TYPES}>
        //                 {t('tienda_nube_account_config.include_all_channels_and_types')}
        //             </option>
        //             <option value={METHOD_ECOMMERCE_SELECT_CHANNELS_AND_TYPES}>
        //                 {t('tienda_nube_account_config.select_channels_and_types')}
        //             </option>
        //         </select>
        //     </div>,
        //     this.renderChannelsAndTypesSelection()
        // ];
    }

    // renderChannelsAndTypesSelection() {
    //     const { t } = this.props;

    //     if (this.state.selectionMethod !== METHOD_ECOMMERCE_SELECT_CHANNELS_AND_TYPES) {
    //         return null;
    //     }

    //     if (this.state.error) {
    //         return (
    //             <div key="error" className="col-12">
    //                 <Alert className="alert-warning">{this.state.error}</Alert>
    //             </div>
    //         );
    //     }

    //     if (this.state.loading) {
    //         return (
    //             <div key="loading" className="col-12">
    //                 <Alert className="alert-info">{t('tienda_nube_account_config.loading_channels_and_types')}</Alert>
    //             </div>
    //         );
    //     }

    //     if (!this.state.allChannelsAndTypes || !Array.isArray(this.state.allChannelsAndTypes) || this.state.allChannelsAndTypes.length === 0) {
    //         return (
    //             <div key="empty" className="col-12">
    //                 <Alert className="alert-warning">{t('tienda_nube_account_config.no_channels_and_types')}</Alert>
    //             </div>
    //         );
    //     }

    //     return (
    //         <div key="multiselect" className="form-row">
    //             <label>{t('tienda_nube_account_config.select_channels_and_types_label')}</label>
    //             {this.renderChannelsAndTypesMultiSelect()}
    //         </div>
    //     );
    // }
}

export const TiendaNubeAccountConfiguration = withTranslation()(TiendaNubeAccountConfigurationClass);
export default TiendaNubeAccountConfiguration;

